import React from 'react';

const NumberFormat = ({ value = 0, decimal = 2 }) => {
    const num = Number(value);
  if (num === 0) return <span>-</span>;
  if (isNaN(num)) return <span>-</span>; // fallback if not a number

  return (
    <span>
      {num === 0
        ? '-'
        : num
            .toFixed(decimal)
            .toString()
            .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
            .replace(/-(.*)/, '($1)')}
    </span>
    //  replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  );
};

export default NumberFormat;
